import request from '@/utils/request'
var http = process.env.BASE_API;
var big_data = "https://wybigdata.q12301.com"
// 今日旅游总人次
export function todayVisitorsData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/today_visitors/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 客流统计
export function realTouristsWYData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/visitor_stats/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 用户画像
export function userPortraitData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/user_portrait/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 景区详情 - 客源地分析
export function visitorSourceData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/scenic/visitor_source/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 30天客流趋势
export function visitorTrendData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/visitor_trend/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 景区排行
export function scenicRankingData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/scenic_ranking/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 首页大屏 - 渠道客流分析
export function channelAnalysisData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/channel_analysis/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 首页大屏 - 客流占比
export function visitorRatioData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/visitor_ratio/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
// 分时客流
export function scenicHourlyData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/hourly/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}

// 情感分析
export function sentimentOverviewData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/sentiment/overview/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}

// 情感分析 - 文章分析
export function sentimentArticlesData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/sentiment/articles/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}

// 情感分析 - 关键词分析
export function sentimentKeywordsData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/sentiment/keywords/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}

// 情感分析 - 源分析
export function sentimentSourcesData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/sentiment/sources/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}

// 情感分析 - 警告分析
export function sentimentWarningsData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/sentiment/warnings/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}

// 情感分析 - 警告分析 - 处理
export function sentimentWarningsHandleData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/api/v1/dashboard/sentiment/warnings/' + query.id + '/handle/',
            method:'post',
            data:query.data
        })
        if(true){
            resolve(returnData);
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/wuyuanApi.js